const zenkakuNumberRegexp = /[０-９]/g;

export const replaceZenkakuNumberWithHankaku = (s: string) =>
  s.replace(zenkakuNumberRegexp, (c: string) => {
    return String.fromCharCode(c.charCodeAt(0) - 65248);
  });
